var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBwThemeBoy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 360,
    height: 360,
    viewBox: "0 0 360 360",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.44 0 0 1.44 0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M181.66,60.97V45.62c0-1.74-1.41-3.15-3.15-3.15h-26.41c-1.74,0-3.15,1.41-3.15,3.15v15.34         c0,1.74,1.41,3.15,3.15,3.15h0.83v3.11l7.65-3.11h17.92C180.25,64.11,181.66,62.7,181.66,60.97z",
    fill: "#a08b6f",
    className: "svgShape color956fa0-0 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M177.55 48.09h-2.75c-.38 0-.68-.3-.68-.68 0-.37.3-.68.68-.68h2.75c.38 0 .68.3.68.68C178.23 47.78 177.93 48.09 177.55 48.09zM170.18 48.09h-17.11c-.38 0-.68-.3-.68-.68 0-.37.3-.68.68-.68h17.11c.38 0 .68.3.68.68C170.86 47.78 170.56 48.09 170.18 48.09zM177.55 53.42h-24.48c-.38 0-.68-.3-.68-.68 0-.37.3-.68.68-.68h24.48c.38 0 .68.3.68.68C178.23 53.11 177.93 53.42 177.55 53.42zM165.31 58.74h-12.24c-.38 0-.68-.3-.68-.68s.3-.68.68-.68h12.24c.38 0 .68.3.68.68S165.69 58.74 165.31 58.74z",
    fill: "#ffffff",
    className: "svgShape colorffffff-1 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M116.38,196.83c-0.11,0.51-2.66,3.28-3.98,3.06c-1.26-0.21-0.15-2.67-0.05-2.9c0,0,0.01-0.01,0.01-0.02       l-10.95-13.25c0,0-16.89,6.2-18,6.63c-1.11,0.44-0.69,1.27-0.69,1.27c-2.2,0.3-2.98-0.37-2.98-0.37       c-1.06-3.35,1.62-4.28,1.62-4.28l13.51-5.23l4.93-2.2l5.11-1.07l9.01-3.27v4.52l-2.94,1.11l2.96,1.11l-0.09,4.83l-5.81-1.86       l6.51,7.64c0,0,0.56,1.09,1.06,2.18C116.04,195.66,116.43,196.59,116.38,196.83z",
    fill: "#5b5a58",
    className: "svgShape color58595b-2 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M99.8,177.91l-18.22-2.43c0,0-2.12-0.21-2.5,1.33c-0.38,1.54,0.43,3.51,0.43,3.51l2.9,0.52       c0,0,0.45-1.26,2.07-0.95c1.62,0.31,10.38,1.87,10.38,1.87l4.93-2.19V177.91z",
    fill: "#706f6d",
    className: "svgShape color6d6e70-3 selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 80.92,
    cy: 181.3,
    r: 1.97,
    fill: "#414140",
    className: "svgShape color404041-4 selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 81.12,
    cy: 192.4,
    r: 1.97,
    fill: "#414140",
    className: "svgShape color404041-5 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M104.92,179.32c0,1.45-5.11,1.45-5.11,0v-28.23h5.11L104.92,179.32z",
    fill: "#848280",
    className: "svgShape color808184-6 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    points: "171.29 114.99 169.79 180.1 166.68 180.84 164.67 179.45 164.19 114.8 166.68 116.19",
    fill: "#73490f",
    className: "svgShape color732b0f-7 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    points: "166.68 116.19 166.68 180.84 164.67 179.45 164.19 114.8",
    fill: "#482d08",
    className: "svgShape color481e08-8 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M124.46,57.99c-1.65,0-2.71-0.97-2.76-1.02c-0.08-0.08-0.08-0.2-0.01-0.28         c0.08-0.08,0.2-0.08,0.28-0.01l0,0c0.01,0.01,1.25,1.14,3.06,0.87c0.11-0.02,0.21,0.06,0.23,0.17         c0.02,0.11-0.06,0.21-0.17,0.23C124.88,57.98,124.66,57.99,124.46,57.99z",
    fill: "#d7a259",
    className: "svgShape colord77b59-9 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M130.87,62.41c0,0,1.89,0.84,4.51,5.06c2.62,4.22,11.67,20.68,11.67,20.68l-10.29,7.06l-7.92-12.66        L130.87,62.41z",
    fill: "#ccb79b",
    className: "svgShape colorccbd9b-10 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M107.68,58.15c0,0-6.62,1.73-9.16,2.74c-2.54,1.01-3.45,2.22-3.45,2.22l-2.72,25.85l-1.27,16.95        l33.54-2.78l4.34-21.1c0,0,2.76-11.53,1.92-19.63l-7.1-2.53l-1.11,0.22l-6.3,2.57l-4.6,0.06L107.68,58.15z",
    fill: "#f3dec2",
    className: "svgShape colorf3dfc2-11 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M99.66 60.48c0 0 2.18 5.66 2.01 13.96-.16 8.3-1.12 30.69-1.12 30.69l2.4-.2 1.01-30.95c0 0 .64-8.51-2.43-14.1L99.66 60.48zM126.39 60.81c0 0 .31 13.29-.51 20.05-.82 6.76-3.58 22.47-3.58 22.47l-1.88.16c0 0 2.88-18 3.49-23.03.61-5.04.51-20.34.51-20.34L126.39 60.81zM130.55 152.07c-.1.57-.21 1.16-.34 1.78-.15.71-.32 1.44-.52 2.19-1.88 7.2-4.75 36.65-4.75 36.65-3.98.59-7.68.39-11.14-.53l.33-31.07.34-4.79.3-4.24.61-8.49h15.78C131.16 143.56 131.43 146.98 130.55 152.07z",
    fill: "#82653c",
    className: "svgShape color82523c-12 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M116.38,196.83c-0.11,0.51-2.66,3.28-3.98,3.06c-1.26-0.21-0.15-2.67-0.05-2.9c0,0,0.01-0.01,0.01-0.02        c0,0,1.39-1.73,3.25-2.24C116.04,195.66,116.43,196.59,116.38,196.83z",
    fill: "#414140",
    className: "svgShape color404041-13 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M114.8,192.4c0,0,0.29,2.85-0.65,4.55c-0.94,1.7,3.03,6.84,3.5,7.1c0.47,0.27,2.68,0,2.91-0.16        c0.23-0.16,2.62-2.09,2.62-2.09L123,199.8c0,0-1.45-2.19-0.69-6.83C119.73,193.12,117.22,192.96,114.8,192.4z",
    fill: "#f3c380",
    className: "svgShape colorf3a880-14 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M132.55,211.53c-0.15,1.22-1.15,2.56-4.78,2.63c-6.72,0.12-11.07-5.79-11.37-6.08        c-0.29-0.29-0.5-0.03-0.87,0.21c-0.37,0.24-3.73-2.92-3.73-2.92s0.05-0.88,0.13-1.98c0.1-1.16,0.24-2.56,0.43-3.4        c0.37-1.62,1.7-2.87,1.7-2.87c0.63,4.68,4.79,5.76,4.79,5.76s0.18-2.76,1.78-3.25c1.6-0.48,2.46,0.28,2.46,0.28        s2.98,3.55,4.93,5.26c1.42,1.24,2.97,3,3.72,3.86c0.47,0.55,0.77,1.23,0.82,1.95C132.58,211.15,132.58,211.34,132.55,211.53z",
    fill: "#9e6d29",
    className: "svgShape color9e3f29-15 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M132.55,211.53c-0.15,1.22-1.15,2.56-4.78,2.63c-6.72,0.12-11.07-5.79-11.37-6.08        c-0.29-0.29-0.5-0.03-0.87,0.21c-0.37,0.24-3.73-2.92-3.73-2.92s0.05-0.88,0.13-1.98c1.78,1.5,10.57,8.78,14.98,9.33        C129.76,213.07,131.55,212.27,132.55,211.53z",
    fill: "#2b1f0f",
    className: "svgShape color2b1e0f-16 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M157.64,147.01l-0.75,2.69l-9.94,35.73l-10.49-2.17l4.8-31.13l1.29-8.38l-2.66-0.86l19.02-2.72        C159.03,143.27,157.64,147.01,157.64,147.01z",
    fill: "#82653c",
    className: "svgShape color82523c-17 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M137.9,183.56c0,0-1.36,4.97-2.18,6.06c-0.82,1.09,5.63,6.24,5.84,6.39c0.2,0.14,4.32,0.29,4.34,0.23        c0.02-0.06,1.23-1.25,1.23-1.25l-0.8-4.22c0,0-2.71-0.85-1.58-5.79L137.9,183.56z",
    fill: "#f3c380",
    className: "svgShape colorf3a880-18 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M153.96,202.98c-6.52,0.61-12.18-3.49-12.18-3.49l-0.63,1.11l-7.2-2.24c0,0-0.13-1.1-0.16-2.37        c-0.02-0.81,0.01-1.69,0.16-2.39c0.36-1.77,1.79-3.99,1.79-3.99c2.07,2.6,5.13,4.37,9.62,4.9c-1.13-2.29,0.67-3.9,1.11-3.83        c0.44,0.08,2.99,2.06,4.5,3.19c1.43,1.06,7.09,3.37,8.12,4.58v0c0.07,0.08,0.11,0.15,0.14,0.22        C159.66,199.81,160.48,202.37,153.96,202.98z",
    fill: "#9e6d29",
    className: "svgShape color9e3f29-19 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M153.96,202.98c-6.52,0.61-12.18-3.49-12.18-3.49l-0.63,1.11l-7.2-2.24c0,0-0.13-1.1-0.16-2.37        c0.13,0.06,3.21,1.57,6.08,2.14c2.94,0.59,5.34,2.11,6.78,2.61c1.44,0.5,14.58,3.26,12.44-2.29c0.07,0.08,0.11,0.15,0.14,0.22        C159.66,199.81,160.48,202.37,153.96,202.98z",
    fill: "#2b1f0f",
    className: "svgShape color2b1e0f-20 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    points: "24.98 114.33 69.49 138.15 225.02 117.14 173.05 98.1 124.61 103.13 91.07 105.92",
    fill: "#c08028",
    className: "svgShape colorc05f28-21 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    points: "24.98 114.33 24.98 117.59 69.38 141.35 69.49 138.15",
    fill: "#73490f",
    className: "svgShape color732b0f-22 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    points: "69.38 141.35 225.02 120.57 225.02 117.14 69.49 138.15",
    fill: "#93621f",
    className: "svgShape color93421f-23 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    points: "84.97 109.26 114.24 124.91 177.09 115.8 141.01 102.58",
    fill: "#d3d2d0",
    className: "svgShape colord0d2d3-24 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    points: "84.97 109.26 84.97 111.4 114.16 127.02 114.24 124.91",
    fill: "#aba9a6",
    className: "svgShape colora6a8ab-25 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    points: "114.16 127.02 177.09 118.05 177.09 115.8 114.24 124.91",
    fill: "#bfbdbb",
    className: "svgShape colorbbbdbf-26 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    points: "28.83 119.65 28.83 136.59 67.22 158.07 67.22 140.19",
    fill: "#482d08",
    className: "svgShape color481e08-27 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    points: "37.32 141.35 35.83 202.68 32.72 203.42 30.71 202.03 30.23 137.38 32.72 138.77",
    fill: "#73490f",
    className: "svgShape color732b0f-28 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    points: "32.72 138.77 32.72 203.42 30.71 202.03 30.23 137.38",
    fill: "#482d08",
    className: "svgShape color481e08-29 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    points: "72.7 155.95 71.21 221.07 68.1 221.81 66.09 220.41 65.61 155.76 68.1 157.16",
    fill: "#73490f",
    className: "svgShape color732b0f-30 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    points: "68.1 157.16 68.1 221.81 66.09 220.41 65.61 155.76",
    fill: "#482d08",
    className: "svgShape color481e08-31 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    points: "217.58 131.05 216.09 196.17 212.98 196.91 210.97 195.52 210.49 130.87 212.98 132.26",
    fill: "#73490f",
    className: "svgShape color732b0f-32 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    points: "212.98 132.26 212.98 196.91 210.97 195.52 210.49 130.87",
    fill: "#482d08",
    className: "svgShape color481e08-33 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M131.16 143.56c0 0 .27 3.42-.61 8.51-.1.57-.21 1.16-.34 1.78l-15.74 2.45.3-4.24.61-8.49H131.16zM157.64 147.01l-.75 2.69-15.64 2.43 1.29-8.38-2.66-.86 19.02-2.72C159.03 143.27 157.64 147.01 157.64 147.01z",
    fill: "#634a27",
    className: "svgShape color633827-34 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    points: "67.22 158.07 225.02 133.52 225.02 120.57 69.38 141.35 67.22 140.19",
    fill: "#73490f",
    className: "svgShape color732b0f-35 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    points: "103.8 109.7 120.59 119.49 156.85 115.33 133.05 104.36",
    fill: "#ffffff",
    className: "svgShape colorffffff-36 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M110.95,57.15l3.41-7.81c0,0-2.46-0.49-2.38-3.17c0.08-2.68,1.35-3.58,2.38-3.24s1.13,1.71,1.04,2.84        c-0.1,1.13-0.19,2.38,0.07,2.59c0.27,0.2,0.63,0,0.66-0.04c0.02-0.04,0.33-2.24,2.28-4.74c1.95-2.5,2.91-4.61,2.97-5.3        c0,0,1.21,3.66,5.36,3.73s6.1-1.92,7.02-0.23c0.92,1.7,0.82,3.93-0.25,6.57c-1.06,2.64-3.89,6.98-6.45,9.38        c-2.56,2.4-4.32,2.6-6.06,2.23c0,0-1.17,1.82-1.8,3.36c-0.63,1.54-2.87,3.44-2.87,3.44S111.35,62.23,110.95,57.15z",
    fill: "#f3c380",
    className: "svgShape colorf3a880-37 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M113.43 48.95c.5.3.93.39.93.39l-.84 1.91L113.43 48.95zM136.21 46.57c-1.49 1.05-2.74 1.91-2.74 1.91.02-.04.03-.08.05-.11 1.06-2.64 1.17-4.87.25-6.57-.92-1.7-2.87.29-7.02.23-4.16-.06-5.36-3.73-5.36-3.73-.06.7-1.02 2.81-2.97 5.3s-2.26 4.69-2.28 4.74c-.02.04-.39.24-.66.04-.27-.2-.17-1.45-.07-2.59.1-1.13-.01-2.5-1.04-2.84-.35-.12-.73-.09-1.09.11 0 0-.72-4.1.85-8.4 1.58-4.3 4.83-3.58 4.83-3.58s2.23-3.63 6.92-2.73c4.69.9 6.78 2.53 7.34 3.64.55 1.11 1.6 1.52 1.99 1.84.39.32 3.33 1.7 2.24 4.55 0 0 2.28 2 2.41 3.69S137.7 45.52 136.21 46.57z",
    fill: "#2b1f0f",
    className: "svgShape color2b1e0f-38 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M125.73 47.02c-.13.13-.34.14-.5.05-.5-.28-2-1.11-2.84-1.38-1.01-.33-1.13-.7-.25-.87.88-.17 1.96.15 2.92.62C125.84 45.84 126.08 46.67 125.73 47.02zM133.25 48.38c-.04.16-.17.24-.32.2-.46-.1-1.83-.4-2.52-.39-.83.01-1.06-.29-.52-.72.54-.43 1.42-.47 2.27-.32C132.85 47.26 133.35 47.96 133.25 48.38zM122.7 52.98c-.55 0-1.1-.16-1.59-.49-1.27-.86-1.63-2.57-.79-3.8.41-.6 1.03-1 1.75-1.12.72-.13 1.46.03 2.07.45 1.27.86 1.63 2.57.79 3.8l0 0C124.42 52.57 123.57 52.98 122.7 52.98zM122.55 47.92c-.14 0-.28.01-.41.04-.62.11-1.15.45-1.49.96-.71 1.05-.41 2.51.69 3.25 1.09.74 2.56.49 3.27-.57.71-1.05.41-2.51-.69-3.25C123.5 48.06 123.03 47.92 122.55 47.92zM124.77 51.7 124.77 51.7 124.77 51.7zM130.4 54.85c-.55 0-1.1-.16-1.59-.49-.62-.42-1.04-1.04-1.19-1.76-.15-.72-.01-1.45.4-2.04.41-.6 1.03-1 1.75-1.12.72-.13 1.46.03 2.07.45 1.27.86 1.63 2.57.79 3.8l0 0C132.12 54.45 131.27 54.85 130.4 54.85zM130.24 49.79c-.14 0-.28.01-.41.04-.62.11-1.15.45-1.49.96-.34.51-.46 1.13-.34 1.74.13.62.49 1.15 1.02 1.51 1.09.74 2.56.49 3.27-.57.71-1.05.41-2.51-.69-3.25C131.2 49.93 130.73 49.79 130.24 49.79zM132.47 53.58 132.47 53.58 132.47 53.58z",
    fill: "#2b1f0f",
    className: "svgShape color2b1e0f-39 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M127.99 51.19c-.07 0-.13-.03-.17-.1-.42-.69-2.03-.7-2.62-.65-.11.01-.21-.07-.22-.18-.01-.11.07-.21.18-.22.1-.01 2.37-.2 3 .84.06.09.03.22-.07.27C128.07 51.18 128.03 51.19 127.99 51.19zM120.38 49.15c-.05 0-.1-.02-.14-.06l-3.91-3.83c-.08-.08-.08-.2 0-.28.08-.08.2-.08.28 0l3.91 3.83c.08.08.08.2 0 .28C120.48 49.13 120.43 49.15 120.38 49.15z",
    fill: "#2b1f0f",
    className: "svgShape color2b1e0f-40 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M125.42 56.29c0 0-.01 0-.01 0-.34-.01-.61-.12-.81-.34-.4-.45-.34-1.16-.33-1.19.01-.11.11-.19.22-.18.11.01.19.11.18.22 0 .01-.05.58.23.89.12.14.29.21.52.21 0 0 0 0 .01 0 .84 0 1.34-2.32 1.45-3.79.01-.11.1-.19.21-.18.11.01.19.1.18.21C127.23 52.56 126.9 56.29 125.42 56.29zM121.01 59.97c-2.58-.92-4.69-3.16-6.34-6.62.83 3.39 2.45 6.33 5.19 8.61L121.01 59.97z",
    fill: "#d7a259",
    className: "svgShape colord77b59-41 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m110.95 57.15-.36-1.21-2.91 2.21c0 0 1.04 8.91 4.24 11.73l3.95-3.58C113.34 63.72 111.43 60.81 110.95 57.15zM120.31 69.25l-3.34-3.06c.71-.68 1.82-1.85 2.24-2.86.63-1.54 1.8-3.36 1.8-3.36.54.11 1.09.17 1.66.13C122.79 64.07 120.31 69.25 120.31 69.25z",
    fill: "#ccb79b",
    className: "svgShape colorccbd9b-42 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M93.28,80.01l-2.21,25.91l-19.44,2.48c0,0-3.1-7.63-0.53-16.26s8.85-10.54,13.7-11.74        C89.67,79.19,93.28,80.01,93.28,80.01z",
    fill: "#2b1f0f",
    className: "svgShape color2b1e0f-43 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M93.28,80.01l-2.21,25.91l-19.44,2.48c0,0-3.1-7.63-0.53-16.26s8.85-10.54,13.7-11.74        C89.67,79.19,93.28,80.01,93.28,80.01z",
    fill: "#979592",
    className: "svgShape color929497-44 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M93.54,77.57l-0.26,2.44c0,0-3.62-0.82-8.48,0.38c-4.86,1.2-11.14,3.11-13.7,11.74        s0.53,16.26,0.53,16.26l-4.52,0.58c0,0-4.73-11.59,0-20.49c4.73-8.9,11.33-10.05,18.51-10.91        C92.8,76.71,93.54,77.57,93.54,77.57z",
    fill: "#848280",
    className: "svgShape color808184-45 selectable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 122.55,
    cy: 50.46,
    rx: 0.67,
    ry: 0.58,
    transform: "rotate(-69.445 122.554 50.462)",
    fill: "#2b1f0f",
    className: "svgShape color2b1e0f-46 selectable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 129.91,
    cy: 52.26,
    rx: 0.67,
    ry: 0.58,
    transform: "rotate(-69.445 129.917 52.258)",
    fill: "#2b1f0f",
    className: "svgShape color2b1e0f-47 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 1.75,
    height: 16.66,
    x: 120.31,
    y: 97.43,
    transform: "rotate(-41.631 121.187 105.766)",
    fill: "#ffb855",
    className: "svgShape color55a6ff-48 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M114.4,99.45l0.59,0.67l1.3-1.16l-0.59-0.67c-0.19-0.22-0.53-0.24-0.74-0.04l-0.52,0.46         C114.23,98.9,114.21,99.23,114.4,99.45z",
    fill: "#ec961e",
    className: "svgShape colorec1e24-49 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    points: "128.17 113.62 127.58 113.32 126.07 112.57 127.37 111.41 127.93 112.95",
    fill: "#faab3e",
    className: "svgShape colorfaad3e-50 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    points: "128.17 113.62 127.58 113.32 127.93 112.95",
    fill: "#443015",
    className: "svgShape color441f15-51 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M125.16,110.1c-0.08,0.95-1.41,0.49-1.41,0.49c0.01,1.5-1.58,1.34-1.58,1.34       c-0.2,0.97-1.76,0.65-1.86,0.63c0.07,0.06,0.6,0.59-1.15,0.55c-1.86-0.04-6.52-1.56-7.59-2.16       c-0.75-0.42-15.56-1.97-24.32-2.86c0,0,0,0,0,0s-0.02,0-0.03,0c-3.71-0.38-6.33-0.63-6.33-0.63s-5.88-0.79-7.23-3.53       c-1.35-2.74,4.35-13.4,4.35-13.4l9.29,5.02l-0.76,1.29l-1.21,2.04c0,0,23.5,6,25.59,6c2.09,0,7.92-0.91,8.71-0.9       c0.79,0.01,3.13,1.46,4.24,2.48C125.01,107.49,125.24,109.15,125.16,110.1z",
    fill: "#f3c380",
    className: "svgShape colorf3a880-52 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M120.31 112.82c-.04 0-.08-.01-.12-.03l-3-1.49c-.13-.07-.19-.23-.12-.37.07-.14.22-.19.37-.12l3 1.49c.13.07.19.23.12.37C120.51 112.77 120.41 112.82 120.31 112.82zM122.17 112.19c-.07 0-.14-.02-.19-.08-.02-.02-1.69-1.64-3.36-2.69-.13-.08-.16-.25-.08-.37.07-.13.25-.17.37-.09 1.73 1.08 3.39 2.69 3.46 2.76.11.1.11.28.01.38C122.31 112.17 122.24 112.19 122.17 112.19zM123.75 110.86c-.11 0-.22-.07-.25-.18-.01-.02-.47-1.35-.95-1.9-.39-.45-1.71-1.05-2.18-1.25-.14-.06-.21-.21-.15-.35.05-.13.21-.21.35-.15.19.08 1.85.77 2.39 1.39s1.03 2.02 1.05 2.07c.05.14-.03.3-.16.35C123.81 110.86 123.79 110.86 123.75 110.86z",
    fill: "#d7a259",
    className: "svgShape colord77b59-53 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M97.2,61.5C91.17,63,83.56,77.37,76.89,89.92l11.06,5.98l4.36-6.51c0,0,4.73-6.66,5.6-11.72       C100.54,62.41,97.2,61.5,97.2,61.5z",
    fill: "#ccb79b",
    className: "svgShape colorccbd9b-54 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M147.92,104.33c-0.41,0.23-0.84,0.46-1.29,0.68c-0.02,0.02-0.04,0.02-0.04,0.02       c-3.48,1.7-7.75,2.85-7.75,2.85c-0.48,1.11-2.64,2.61-4.17,3.07c-1.53,0.46-1.77-0.02-1.77-0.02s-0.49,0.54-1.01,0.46       c-0.77-0.12-0.89-0.5-0.89-0.5s-0.4,0.3-1.1,0.24c-0.7-0.07-0.77-0.82-0.77-0.82c-0.86,0.7-2.12-0.05-1.28-1.38       c0.85-1.34,2.84-5.12,3.91-5.58c1.08-0.47,4.02,0.46,4.02,0.46c0.76-0.18,4.59-4.55,4.59-4.55l-1.89-2.99l-0.99-1.57l8.45-5.8       c0,0,4.63,7.84,5.23,9.53C151.77,100.13,151.53,102.26,147.92,104.33z",
    fill: "#f3c380",
    className: "svgShape colorf3a880-55 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M130.32 104.91c0 0-1.95 1.4-2.55 1.72-.59.32-.9.5-1 1.01-.09.5.49 1.21 1.22 1.05L130.32 104.91zM129.13 110.59c-.04 0-.09-.01-.13-.03-.13-.07-.18-.24-.11-.37.08-.16 2.16-3.96 3.62-5.2.12-.1.29-.08.38.03.1.11.08.29-.03.38-1.39 1.17-3.48 5-3.5 5.04C129.32 110.54 129.22 110.59 129.13 110.59zM131 111.18c-.05 0-.1-.01-.14-.04-.13-.08-.16-.25-.09-.37.09-.15 2.23-3.67 3.16-4.63.11-.11.28-.11.39 0 .11.1.11.28.01.38-.89.91-3.07 4.49-3.09 4.53C131.18 111.13 131.09 111.18 131 111.18zM132.83 111.32c-.05 0-.11-.02-.15-.05-.13-.09-.15-.26-.07-.38.07-.1 1.74-2.46 3.48-3.64.12-.08.29-.05.38.07.08.12.05.29-.07.38-1.66 1.12-3.32 3.48-3.34 3.5C133 111.28 132.92 111.32 132.83 111.32zM123.16 58.66c-1.32 0-2.36-.95-2.42-1-.08-.07-.08-.19-.01-.27.07-.08.19-.08.27-.01.02.01 1.62 1.47 3.23.64.09-.05.21-.01.25.08s.01.21-.08.25C123.98 58.57 123.56 58.66 123.16 58.66zM87.22 108.1c-3.71-.38-6.33-.63-6.33-.63s-5.88-.79-7.23-3.53c-1.35-2.74 4.35-13.4 4.35-13.4l9.29 5.02-.76 1.29-6.6-2.57c0 0-5.72 4.86-4.51 8.45C76.62 106.19 86.6 107.99 87.22 108.1zM147.92 104.33c-.41.23-.84.46-1.29.68.25-.16 1.64-1.14 2.56-4.17.37-1.22.06-2.68-.48-4.03-1.02-2.56-4.04-3.66-6.49-2.42l-3.73 1.89-.99-1.57 8.45-5.8c0 0 4.63 7.84 5.23 9.53C151.77 100.13 151.53 102.26 147.92 104.33z",
    fill: "#d7a259",
    className: "svgShape colord77b59-56 selectable"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBwThemeBoy);
export default __webpack_public_path__ + "static/media/bwTheme-boy.a221206e474a79d6a35e03ea78e53995.svg";
export { ForwardRef as ReactComponent };